enum ActionTypes {
  LOAD_VIMEO_ASSETS = 'nextiq/Shared/Vimeo/LOAD_VIMEO_ASSETS',
  LOAD_VIMEO_ASSETS_SUCCESS = 'nextiq/Shared/Vimeo/LOAD_VIMEO_ASSETS_SUCCESS',
  LOAD_VIMEO_ASSETS_FAILURE = 'nextiq/Shared/Vimeo/LOAD_VIMEO_ASSETS_FAILURE',
  LOAD_VIMEO_EPISODES = 'nextiq/Shared/Vimeo/LOAD_EPISODES_ASSETS',
  LOAD_VIMEO_EPISODES_SUCCESS = 'nextiq/Shared/Vimeo/LOAD_VIMEO_EPISODES_SUCCESS',
  LOAD_VIMEO_EPISODES_FAILURE = 'nextiq/Shared/Vimeo/LOAD_VIMEO_EPISODES_FAILURE',
}

export default ActionTypes;